import { EstadoFinanceiroComissao, LancamentoComissao } from '@/types/comissao'

/**
 * Rótulo e cor de cada etapa do ciclo (Figma 37:2). O estado vem DERIVADO do backend
 * (`EstadoFinanceiroComissao.derivar`); aqui só se traduz para a tela.
 */
export const ESTADO_FINANCEIRO: Record<
  EstadoFinanceiroComissao,
  { rotulo: string; cor: 'default' | 'info' | 'warning' | 'primary' | 'success' }
> = {
  PROJETADA: { rotulo: 'Projetada', cor: 'default' },
  AGUARDANDO_NF: { rotulo: 'Aguardando NF', cor: 'warning' },
  NF_RECEBIDA: { rotulo: 'NF recebida', cor: 'info' },
  // AN-9 (Q36): a nota da linha tem pendência aberta — pagamento bloqueado até resolver.
  NF_COM_PENDENCIA: { rotulo: 'NF com pendência', cor: 'warning' },
  PROGRAMADO: { rotulo: 'Programado', cor: 'primary' },
  PAGO: { rotulo: 'Pago', cor: 'success' },
  CANCELADA: { rotulo: 'Cancelada', cor: 'default' },
  // P5 (PP5-valr B3): o par estornado nunca "aguarda NF".
  ESTORNO: { rotulo: 'Estorno', cor: 'default' },
  ESTORNADO: { rotulo: 'Estornado', cor: 'default' },
}

/**
 * Estado da linha. Usa o campo derivado do backend; se ele faltar (backend anterior ao
 * A15), cai no mínimo que os campos antigos permitem dizer — sem inventar "Programado"
 * nem "Pago", que dependem de dados que só o backend novo devolve.
 */
export const estadoDe = (l: LancamentoComissao): EstadoFinanceiroComissao => {
  if (l.estadoFinanceiro) return l.estadoFinanceiro
  if (l.tipo === 'ESTORNO') return 'ESTORNO'
  if (l.estornado) return 'ESTORNADO'
  if (l.status === 'CONFIRMADA') return l.disponivelParaNota ? 'AGUARDANDO_NF' : 'NF_RECEBIDA'
  return l.status
}

export const brl = (v: number | null | undefined): string =>
  v == null ? '—' : v.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
